export const customizeDate = (date: string) => {
  return date.slice(0, 10).replace(/-/gi, '. ')
}
